import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

/**
 * Число для пункта «Цены» — та же формула, что на главной (synonym_prices_count / number_of_prices).
 */
export default function getSectionMenuPricesCount(
  lpu: Lpu,
  synonymPricesCount?: number,
): number {
  return synonymPricesCount || lpu.number_of_prices || 0
}
